import { render, staticRenderFns } from "./dueForDehorning.vue?vue&type=template&id=606be814&scoped=true&"
import script from "./dueForDehorning.vue?vue&type=script&lang=js&"
export * from "./dueForDehorning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606be814",
  null
  
)

export default component.exports